import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, TextField, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import axios from 'axios';

const API_URL = '/api/pago_fernando';

function formatReal(value) {
  if (value === '' || value === undefined) return '';
  let num = value;
  if (typeof num === 'string') {
    num = num.replace(/\D/g, '');
    if (num === '') return '';
    num = parseFloat(num);
  }
  return (num / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function formatDateBR(dateStr) {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length !== 3) return dateStr;
  const [y, m, d] = parts;
  return `${d}/${m}/${y}`;
}

function toCents(value) {
  if (value === '' || value === undefined || value === null) return 0;
  let raw = String(value).replace(/\D/g, '');
  if (raw === '') return 0;
  return parseInt(raw, 10);
}

function PagoFernando() {
  const [dados, setDados] = useState([]);
  const [form, setForm] = useState({ valor: '', data: '', responsable: '', nota: '' });
  const [editId, setEditId] = useState(null);

  const fetchDados = async () => {
    const res = await axios.get(API_URL);
    setDados(res.data);
  };

  useEffect(() => {
    fetchDados();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      valor: toCents(form.valor),
      data: form.data,
      responsable: form.responsable,
      nota: form.nota,
    };
    if (editId) {
      await axios.put(`${API_URL}/${editId}`, payload);
    } else {
      await axios.post(API_URL, payload);
    }
    setForm({ valor: '', data: '', responsable: '', nota: '' });
    setEditId(null);
    fetchDados();
  };

  const handleEdit = (item) => {
    setForm({
      valor: item.valor,
      data: item.data,
      responsable: item.responsable,
      nota: item.nota || '',
    });
    setEditId(item.id);
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API_URL}/${id}`);
    fetchDados();
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Valor Pago ao Fernando</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <form onSubmit={handleSubmit}>
          <TextField label="Valor" name="valor" value={form.valor} onChange={handleChange} required sx={{ mr: 2 }} />
          <TextField label="Data" name="data" value={form.data} onChange={handleChange} required sx={{ mr: 2 }} />
          <TextField label="Responsável" name="responsable" value={form.responsable} onChange={handleChange} required sx={{ mr: 2 }} />
          <TextField label="Nota" name="nota" value={form.nota} onChange={handleChange} sx={{ mr: 2 }} />
          <Button type="submit" variant="contained" color="primary">{editId ? 'Salvar' : 'Adicionar'}</Button>
          {editId && (
            <Button onClick={() => { setEditId(null); setForm({ valor: '', data: '', responsable: '', nota: '' }); }} sx={{ ml: 2 }}>Cancelar</Button>
          )}
        </form>
      </Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Valor</TableCell>
            <TableCell>Data</TableCell>
            <TableCell>Responsável</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dados.map((item) => (
            <TableRow key={item.id}>
              <TableCell>{formatReal(item.valor)}</TableCell>
              <TableCell>{formatDateBR(item.data)}</TableCell>
              <TableCell>{item.responsable}</TableCell>
              <TableCell>
                <Button size="small" onClick={() => handleEdit(item)}>Editar</Button>
                <Button size="small" color="error" onClick={() => handleDelete(item.id)}>Excluir</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}

export default PagoFernando;
